// utilities/useServiceUpdate.ts
import { ref } from "@vue/composition-api";

export default function () {
    const refreshing = ref(false);

    const updateAvailable = (event: any) => {
        const reg: ServiceWorkerRegistration | undefined = event?.detail;
        const waiting = reg?.waiting;

        if (waiting) {
            // Ask the waiting SW to activate immediately
            waiting.postMessage({ type: "SKIP_WAITING" });
        } else {
            // Fallback: nuke SWs (old browsers / edge cases) then reload
            navigator.serviceWorker.getRegistrations().then((regs) => {
                for (const r of regs) r.unregister();
                window.location.reload();
            });
        }
    };

    // Listen once per page load; subsequent loads will re-attach this
    document.addEventListener("swUpdated", updateAvailable, { once: true });

    // When the new SW takes control, reload exactly once
    navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing.value) return;
        refreshing.value = true;
        window.location.reload();
    });

    // no UI bindings needed anymore
    return {};
}